// extracted by mini-css-extract-plugin
export default {"container":"CreateTaskPage_container__MgzGn","titleStrict":"CreateTaskPage_titleStrict__ypz6r","statusWrapper":"CreateTaskPage_statusWrapper__-y99Q"};